import * as React from "react";
import Checkbox from "../../../primitiveComponents/form/Checkbox/Checkbox";
import { toggleFeature } from "../../Features/enabledFeaturesHelpers";
import { ActionEditProps } from "../../Actions/pluginRegistry";
import { ExpandableFormSection, Summary } from "../../form";

const StringProperties = {
    "Octopus.Action.Package.JsonConfigurationVariablesTargets": "",
    "Octopus.Action.EnabledFeatures": "",
};

export type StructuredConfigurationProperties = { [P in keyof typeof StringProperties]: string };

const StructuredConfigurationVariablesToggle = (props: ActionEditProps<StructuredConfigurationProperties>) => {
    const featureEnabled = props.properties["Octopus.Action.EnabledFeatures"]?.includes("Octopus.Features.JsonConfigurationVariables");

    function summary() {
        if (featureEnabled) {
            return Summary.summary(<span>Variable replacement will be performed on the target files</span>);
        } else {
            return Summary.placeholder(<span>No variable replacement will be performed</span>);
        }
    }

    function handleChange() {
        props.setProperties({ ["Octopus.Action.EnabledFeatures"]: toggleFeature(props.properties["Octopus.Action.EnabledFeatures"], "Octopus.Features.JsonConfigurationVariables") }, true);
    }

    return (
        <ExpandableFormSection errorKey="jsonvariables" isExpandedByDefault={props.expandedByDefault} title="Structured Configuration Variables" summary={summary()} help="Enable file variable replacements">
            <Checkbox label="Enable" value={featureEnabled} onChange={handleChange} error={props.getFieldError("Octopus.Action.Package.JsonConfigurationVariablesTargets")} />
        </ExpandableFormSection>
    );
};

export default StructuredConfigurationVariablesToggle;
